export const SORTKEYS = [
  {
    key: "info.type",
    label: "trackManager.sortActivityType",
  },
  {
    key: "info.name",
    label: "trackManager.sortActivityName",
  },
  {
    key: "stats.time.startTime",
    label: "trackManager.sortActivityStartTime",
  },
  {
    key: "file.fileImportDate",
    label: "trackManager.sortFileUploadedTime",
  },
  {
    key: "stats.duration.duration",
    label: "trackManager.sortDurationSeconds",
  },
  { key: "stats.distance.total", label: "trackManager.sortDistance" },
  {
    key: "stats.elevation.ascent",
    label: "trackmanager.sort_elevationUp",
  },
  {
    key: "stats.heartrate.average",
    label: "trackManager.sortHeartrateAvg",
  },
  {
    key: "stats.speed.average",
    label: "trackManager.sortSpeedAvg",
  },
  {
    key: "stats.pace.average",
    label: "trackManager.sortPaceAvg",
  },
];
/**
 * Sorts an array of track objects based on a specified key and order.
 * Assumes the keys are flattened strings (e.g., "stats.distance.total").
 *
 * @param {Array<Object>} tracksIndex The array of track objects to be sorted.
 * @param {string} sortKey The key (string) by which to sort the array (e.g., "stats.distance.total").
 * @param {'asc' | 'desc'} sortOrder The sort order, either 'asc' for ascending or 'desc' for descending.
 * @returns {Array<Object>} A new sorted array of track objects.
 */
export function getSortedTracks(tracksIndex, sortKey, sortOrder) {
  // Always create a shallow copy to avoid modifying the original array
  const sortedArray = [...tracksIndex];

  // If no sortKey is provided, return the unsorted copy
  if (!sortKey) {
    return sortedArray;
  }

  sortedArray.sort((a, b) => {
    const valA = a[sortKey];
    const valB = b[sortKey];

    // Handle undefined/null values: push them to the end
    // If valA is null/undefined, it comes after valB (for asc)
    // If valB is null/undefined, it comes after valA (for asc)
    if (valA === undefined || valA === null) {
      return sortOrder === "asc" ? 1 : -1;
    }
    if (valB === undefined || valB === null) {
      return sortOrder === "asc" ? -1 : 1;
    }

    // Compare values based on their type
    if (typeof valA === "string" && typeof valB === "string") {
      return sortOrder === "asc"
        ? valA.localeCompare(valB)
        : valB.localeCompare(valA);
    } else {
      // For numbers, booleans, or other comparable types
      if (valA < valB) {
        return sortOrder === "asc" ? -1 : 1;
      }
      if (valA > valB) {
        return sortOrder === "asc" ? 1 : -1;
      }
      return 0; // Values are equal
    }
  });

  return sortedArray;
}
